import React from "react";
import { Fragment } from "react";

export default function BroadCastEmailHeader() {
  return (
    <Fragment>
      <div className="row customers">
        <div className="col-sm-12">
          <h2>Broadcast Email</h2>
        </div>
      </div>
    </Fragment>
  );
}
